module.exports = __webpack_public_path__ + "img/puberty-decal-29.51de8b63.png";